import {Pipe, PipeTransform, SecurityContext} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {Action} from './action';

@Pipe({
  name: 'inlineActions',
  standalone: true
})
export class InlineActionsPipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) {
  }

  transform(value: string, ...args: any[]): SafeHtml {
    // the user input needs to be sanitized
    const saneValue = this.domSanitizer.sanitize(SecurityContext.HTML, value);

    // but tags that this pipe adds, must not
    return this.domSanitizer.bypassSecurityTrustHtml(this.stylize(saneValue, args[0]));
  }

  private stylize(description: string, actions: Action[]): string {
    let html = `<div class="paragraph">${description}</div>`; // not using <p> bc it auto closes on some input
    if (actions) {
      for (const action of actions) {
        if ('inline' in action) {
          const classAtt = `class="${action.inline.hidden ? 'hidden-action' : 'inline-action'}"`;
          const onclickAtt = 'onclick="evt = document.createEvent(\'HTMLEvents\'); evt.initEvent(\'change\', false, true); ' +
            `document.getElementById('message-to-ng').value = '${action.place}'; ` +
            'document.getElementById(\'message-to-ng\').dispatchEvent(evt)"';
          html = html.replace(action.inline.mark + action.inline.fragment,
            `<span ${classAtt} ${onclickAtt}>${action.inline.fragment}</span>`);
        }

      }
    }

    return html.replace('&#10;&#10;', '</div><div class="paragraph">');
  }
}
